import { ViewportContent } from '~/src/store';

export const allImagesHasLoaded = (viewportDataArray: Array<ViewportContent>) => {
  const viewportsImageIsLoaded = viewportDataArray.filter((viewportDataItem) => viewportDataItem.imageIsLoaded);
  return viewportDataArray.length === viewportsImageIsLoaded.length;
};
